<template>
    <div class="yd-news-wutu" @click="newsClick(newsData.newsContentURL)">
        <p v-if="newsData.newsContentTitle" class="yd-title">{{newsData.newsContentTitle}}</p>
        <div v-if="newsData.newsContentSource" class="yd-module-label">
            <span>{{newsData.newsContentSource}}</span>
            <span v-if="newsData.newsContentUpdateTime">{{newsData.newsContentUpdateTime}}</span>
            <span v-else>{{getCurrentTime()}}</span>
        </div>
    </div>
</template>
<script>
export default {
    props: ["newsData"],
    methods: {
        newsClick(url) {
            this.$emit('newsClick', url);
        },
        //获取当前时间，格式为："2017-5-12 17:59:12"
        getCurrentTime() {
            return new Date().toLocaleString();
        }
    }
}
</script>
<style lang="less">
/*无图新闻*/
.yd-news-wutu {
    margin-top: 10px;
    cursor: pointer;
    .yd-title {
        text-align: left;
        font-size: 14px;
        margin-bottom: 10px;
    }
    .yd-module-label {
        text-align: left;
        color: #8492A6;
        font-size: 12px;
        span {
            padding-right: 10px;
        }
    }
}
</style>




// WEBPACK FOOTER //
// NoneImg.vue?4e8cf026